<template>
    <div class="body">
      <div class="header">
        <el-form :model="FindCloutManageDTO" :inline="true">
          <el-form-item>
            <el-button @click="submit" size="small" type="primary">下载</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>

        </el-form>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="id"
            align="center"
            label="id"
          ></el-table-column>

          <el-table-column
      prop="thumbnail"
      label="缩略图"
      align="center"
      >
   <template slot-scope="scope">
   <el-popover placement="top-start" trigger="click">
   <!--trigger属性值：hover、click、focus 和 manual-->
   <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
   <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
    </a>
    <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
    </el-popover>
   </template>
  </el-table-column>
  <el-table-column
            prop="createTime"
            align="center"
            label="存入日期"
          ></el-table-column>
        </el-table>
      </div>

  

    </div>
  </template>

  <script>
  import {fontLibrarySelectInfo,fontLibraryBatchDelete} from '@/api/fontLibrary'
  export default {
    data() {
      return {
        pageSize: 30,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        dialogVisible: false,
        ids: '',
        date: '',
        buttonInfo:[],
        conTract: [],
        FindCloutManageDTO:{
            startTime: '',
            endTime: '',
            access: '',
        },
        accountForm: {

          },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }
      }
    },

    async  mounted() {
      this.FindCloutManageDTO.access=localStorage.getItem("access")
      this.getTable(); // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTable()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTable()
      },

    getTable() {
        fontLibrarySelectInfo(this.currentPage, this.pageSize, this.FindCloutManageDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      handleSelectionChange(val) {
      this.DeleteDTO=val
      this.multipleSelection = val;
    },
    handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
          if(this.multipleSelection.length>1){
            this.$message({
              type: "error",
              message: "sorry,一次只能删除一条数据!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            fontLibraryBatchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
        getCurrentTime() {
          //获取当前时间并打印
          var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
      console.log(_this.gettime)
      return _this.gettime;
      },
      submit() {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选任何文件呢!"
              });
              return;
            }
            this.$message({

                  type: 'success',
                  message: '正在死命下载中,请稍等!!!!',
                }),
                console.log(this.multipleSelection)
        fetch("api/serviceCenter/font/download", {
        body: JSON.stringify(this.multipleSelection),
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then(res => {
        this.getTable()
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        a.href = blobUrl;
        let time= this.getCurrentTime();
        a.download =time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      });
      });
      }

    }
  }
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
    padding-bottom: 50px;
  }

  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
